__turbopack_context__.v({
  "className": "geist_7a2af4ec-module__w1EmjG__className",
  "variable": "geist_7a2af4ec-module__w1EmjG__variable",
});
